import { render, staticRenderFns } from "./ToolboxTalkLibraryItemForm.vue?vue&type=template&id=abbb56f6&"
import script from "./ToolboxTalkLibraryItemForm.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkLibraryItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports